module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpcV9ugnB9nGBxhGh2jl9ug19ug15ug15tgmNxh19uhF9tgl9uhGBthV9vhF9ug19ug15tgl5ug15tg15ug15tgk84yPgAAAAVdFJOUwCQBiYP5Fzw+Rpux0w/Mn6p29K5nkqZ53YAAACzSURBVCjPjZJZEoQgDETjBojKoub+V52INY5Cq9NfiXlCqhtS89rSi/rQWdLMc//CRWZNKzPH5olrOkEqSmTn7jmnd46okkJPd9y0cX6vrZRmxNxoZGi/nZLOKMTlk/SfL7nyrunY+CwPtk8ehPryrYJ+bK7yciaTb8DhdpDBcMRZhy0JmFm78C/OS5MrHbJflh1fKIUk6/dzvjA0ZGxiaQG0GJqKQsMxwedi6Q+5IYIH8gEyHQzVDJupYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/unfold.png
// module id = 686
// module chunks = 0